var _rect, _path, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToothRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4659 47.1626C43.3928 47.2584 44.0635 62.5005 48.7569 62.5C51.7281 62.4991 53.642 58.6653 54.0249 48.7927C54.4082 38.9193 60.8259 36.7141 58.719 25.212C56.6114 13.7096 43.01 20.4785 39.4658 20.4785C35.921 20.4785 22.3192 13.7097 20.2124 25.212C18.105 36.7141 24.5222 38.9193 24.9063 48.7927C25.289 58.6653 27.2039 62.4991 30.1743 62.5C34.8676 62.5007 35.5385 47.2587 39.4659 47.1626Z",
    fill: "white",
    stroke: "#F08C8C",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.6272,
    cy: 28.6118,
    rx: 3.2795,
    ry: 3.2795,
    fill: "#F08C8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToothRed);
export default __webpack_public_path__ + "static/media/tooth-red.e0b209af3705d76b8de1c660a3baa3bb.svg";
export { ForwardRef as ReactComponent };